import * as React from "react";
import {
  Flex
} from "@chakra-ui/react";

import { ContactForm } from "../../Form";
import { Stack } from "../../Stack";


interface Props {
  node: any
  avatars?: any[] | undefined
}


export const Contact: React.FC<Props> = ( props ) => {
  return (
    <Flex
      direction={{
        base: 'column-reverse',
        lg: 'row'
      }}
      justify="flex-start"
      align="flex-start"
      gap={{
        base: '60px',
        lg: '120px',
        xl: '196px'
      }}
      w="100%"
    >
      <ContactForm />
      <Stack
        layout="contact"
        nodes={[1]}
        avatars={ props.avatars }
        hasButton
      />
    </Flex>
  )
}
